import React, { useRef } from "react";
import { post_site_image } from "http/components/SiteData";
import MButton from "./MButton";
import {
  setHomeData,
  setSocialData,
  setTamimaData,
} from "../../Redux/slices/mngrSlice";
import { HandleLoading } from "./ApiServices";
import { useDispatch } from "react-redux";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { enqueueSnackbar } from "notistack";

export default function MPageImage({ page, image, onChange }) {
  const fileRef = useRef();
  const dispatch = useDispatch();
  const onUploadImage = async (e) => {
    if (e.target.files[0]) {
      dispatch(HandleLoading(true));
      let formData = new FormData();
      formData.append("section", page);
      formData.append("image", e.target.files[0]);
      const response = await post_site_image(formData);
      if (CheckApiStatus(response)) {
        switch (page) {
          case "home":
            dispatch(setHomeData(true));
            break;
          case "tamima":
            dispatch(setTamimaData(true));
            break;
          case "social":
            dispatch(setSocialData(true));
            break;
          default:
            console.log("error in name page");
            break;
        }
        enqueueSnackbar("Upload image Success", { variant: "success" });
      } else {
        enqueueSnackbar("Upload image Error", { variant: "error" });
      }
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Some error in upload file exist", { variant: "error" });
    }
  };
  return (
    <div className="m-page-image">
      {image ? (
        <>
          {["webm", "mp4"].includes(/[^.]+$/.exec(image)[0]) ? (
            <video autoPlay loop className="video-box">
              <source src={image} type="video/webm" />
            </video>
          ) : (
            <img src={image} alt={`${page}-page-image`} />
          )}
        </>
      ) : (
        "No image found for this section"
      )}
      <input
        accept=".jpg,.png,.webp,.webm,.mp4"
        id="file-iploader"
        type="file"
        hidden
        onChange={onUploadImage}
        ref={fileRef}
      />
      <MButton
        onClick={() => fileRef.current.click()}
        label={image ? "Change Image" : "Upload Image"}
      />
    </div>
  );
}
